import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

import TextLoading from "../../../components/global/TextLoading";

/**
 * Warns the user about unsaved changes when they try to navigate away from the
 * report card editor (internal react-router navigation). Offers three choices:
 * stay, leave discarding the changes, or save and then leave.
 * Only used for in-app navigation; browser refresh/close falls back to the
 * native beforeunload dialog, which cannot be customized.
 */
export default function LeaveWithoutSavingModal(props) {
  const [t] = useTranslation(["reportCards", "global"]);
  return (
    <Modal show={props.show} size="lg" aria-labelledby="contained-modal-title-lg">
      <Modal.Header>
        <Modal.Title>
          {t("reportCards:leaveWithoutSavingModal.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>{t("reportCards:leaveWithoutSavingModal.message")}</Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            id="leaveWithoutSavingCancelButton"
            variant="light"
            onClick={props.onStay}
            disabled={props.saving}
          >
            {t("global:buttons.cancel")}
          </Button>
          <Button
            id="leaveWithoutSavingLeaveButton"
            variant="outline-danger"
            onClick={props.onLeave}
            disabled={props.saving}
          >
            {t("reportCards:leaveWithoutSavingModal.leave")}
          </Button>
          <Button
            id="leaveWithoutSavingSaveButton"
            variant="primary"
            onClick={props.onSaveAndLeave}
            disabled={props.saving}
          >
            {props.saving ? (
              <TextLoading text={t("global:buttons.saving")} variant="light" />
            ) : (
              t("reportCards:leaveWithoutSavingModal.saveAndLeave")
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

LeaveWithoutSavingModal.propTypes = {
  show: PropTypes.bool,
  saving: PropTypes.bool,
  onStay: PropTypes.func,
  onLeave: PropTypes.func,
  onSaveAndLeave: PropTypes.func,
};
